// Regole del Box Mensile (modello ibrido) — allineate a backend/helpers.py
export const BOX_PRICE = 79.0;      // prezzo fisso mensile
export const BOX_MAX_VALUE = 92.0;  // valore massimo di listino dei prodotti inseribili
export const BOX_MIN_PRODUCTS = 4;  // numero minimo di prodotti diversi
export const BOX_MIN_VALUE = 77.0;  // valore minimo di listino per pagare (79€ fissi - max 2€ di credito)
export const BOX_MAX_CREDIT = 2.0;  // resto massimo convertito in credito account
export const euro = (n) => `€${Number(n).toFixed(2).replace(".", ",")}`;
